if (!customElements.get('search-form')) {
  class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.js-search-input');
      this.productTypeSelect = this.querySelector('.js-search-product-types');
      this.productTypeInput = this.querySelector('.js-search-product-type-value');
      this.resetBtn = this.querySelector('.js-search-reset');
      if (!this.input) return;
      this.input.placeholder = this.input.dataset.placeholderOne || this.input.placeholder;
      this.input.addEventListener('input', this.handleInput.bind(this));
      this.productTypeSelect?.addEventListener('change', this.handleProductTypeChange.bind(this));
      this.resetBtn?.addEventListener('click', this.handleReset.bind(this));
      this.handleInput();
    }

    handleInput() {
      const hasValue = this.input.value.length > 0;
      this.input.classList.toggle('search__input--dirty', hasValue);
      if (this.resetBtn) this.resetBtn.hidden = !hasValue;
    }

    handleProductTypeChange(evt) {
      if (this.productTypeInput) this.productTypeInput.value = evt.detail.selectedValue;
    }

    handleReset() {
      this.input.value = '';
      this.input.dispatchEvent(new Event('input', { bubbles: true }));
      this.input.focus();
    }
  }

  customElements.define('search-form', SearchForm);
}
